import React from 'react';
import { ReactComponent as SendIcon } from './../../images/send-arrow.svg';
import {
  Form,
  Header,
  Page,
  SubmitButton,
  Text,
  TextArea,
  Wrapper,
} from './ReviewPage.styles';

const ReviewPage = ({ data }) => {
  return (
    <Page>
      <Wrapper>
        <Header>{data.title}</Header>
        <Text>{data.subtitle}</Text>
        <Form action='https://formsubmit.co/support@eou-edu.eu' method='POST'>
          <TextArea
            name='content'
            id='content'
            placeholder={data.contentPlaceholder}
          ></TextArea>
          <input
            type='hidden'
            name='_next'
            value={`${window.location.origin}/${data.language}/thankyou`}
          ></input>
          <SubmitButton type='submit'>
            {data.submitButton} <SendIcon />
          </SubmitButton>
        </Form>
      </Wrapper>
    </Page>
  );
};

export default ReviewPage;
